export default __webpack_public_path__ + "static/media/screen_dropbox_3_1.f182dc89.png";